import React from 'react';
import { createPortal } from 'react-dom';

function Portal({ selectorId = 'body', children }) {
  return (createPortal(children, document.querySelector(selectorId)))
}

export default Portal;